import * as Icons from "lucide-react";

export function Icon({ name, ...props }) {
  const C = Icons[name] || Icons.Sparkles;
  return <C {...props} />;
}
